import { createContext, useContext } from 'react';

export const IncomeIQueueContext = createContext();

export const useIncomeIQueueContext = () => useContext(IncomeIQueueContext);
